export default __webpack_public_path__ + "static/media/alert.e931259d.gif";